// Synthesized Web Audio sfx (no files — ТЗ 4.4). Each call builds a short
// oscillator→gain envelope. Optional & guarded; Safari resume on first gesture.
const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
let actx: AudioContext | null = null;
try { actx = new Ctx(); } catch { actx = null; }

export function resumeAudio(): void { if (actx && actx.state === 'suspended') actx.resume(); }

function tone(freq: number, dur: number, type: OscillatorType, vol: number, slideTo?: number): void {
  if (!actx || actx.state === 'suspended') return;
  try {
    const t0 = actx.currentTime;
    const osc = actx.createOscillator();
    const gain = actx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t0);
    if (slideTo) osc.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), t0 + dur);
    gain.gain.setValueAtTime(vol, t0);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(gain); gain.connect(actx.destination);
    osc.start(t0); osc.stop(t0 + dur);
  } catch { /* ignore */ }
}

export const playBounce = () => tone(220, 0.09, 'sine', 0.18);
export const playPass = (combo: number) => tone(420 + Math.min(combo, 10) * 55, 0.10, 'triangle', 0.16);
export const playGreen = () => { tone(523, 0.10, 'sine', 0.2); tone(784, 0.16, 'sine', 0.18); };
export const playSmash = () => tone(180, 0.14, 'sawtooth', 0.16, 60);
export const playDeath = () => tone(300, 0.45, 'sawtooth', 0.22, 70);
export const playGoal = () => { tone(523, 0.12, 'sine', 0.2); tone(659, 0.12, 'sine', 0.2); tone(784, 0.2, 'sine', 0.2); };
